/* Presell page interactions: scroll reveal, count-up stats, progress bars */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = '.ps__head, .ps-card, .ps-gal__filters, .ps-mt__media, .ps-mt__copy, .ps-rev__stage, .ps-video__frame, .ps-calc__card, .ps-buy__gallery, .ps-buy__info, .ps-acc details, .ps-hero__copy';

  function countUp(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    var raw = el.textContent.trim();
    var m = raw.match(/^([^0-9]*)([0-9]+(?:\.[0-9]+)?)(.*)$/);
    if (!m || reduce || (window.Shopify && window.Shopify.designMode)) return;
    var prefix = m[1], target = parseFloat(m[2]), suffix = m[3];
    var decimals = (m[2].split('.')[1] || '').length;
    var start = null, duration = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init(scope) {
    var els = (scope || document).querySelectorAll('.ps ' + targets.split(', ').join(', .ps '));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    document.documentElement.classList.add('ps-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        e.target.querySelectorAll('.ps-card__stat').forEach(countUp);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      if (el.classList.contains('ps-reveal')) return;
      var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--ps-delay', Math.min(siblings, 5) * 0.08 + 's');
      el.classList.add('ps-reveal');
      io.observe(el);
    });
  }

  var design = !!(window.Shopify && window.Shopify.designMode);
  function settle(scope) {
    (scope || document).querySelectorAll('.ps .ps-card, .ps .ps-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
  function boot(scope) {
    init(scope);
    if (design) settle(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    settle(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) { settle(e.target.closest('.ps') || e.target); });
  if ('MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function (muts) {
      var hit = false;
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && (n.matches('.ps, .ps-card, [id^="shopify-section"]') || n.querySelector('.ps-card, .ps'))) hit = true;
        });
      });
      if (!hit) return;
      clearTimeout(pending);
      pending = setTimeout(function () { boot(); if (design) settle(); }, 60);
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();

